<template>
  <div class="w-100" v-if="content && page">
    <v-container>
      <v-row class="justify-center">
        <v-col :cols="$vuetify.breakpoint.smAndDown ? 12 : 9">
          <PostBlock :html="content.data"></PostBlock>
        </v-col>
      </v-row>
      <v-row class="justify-center">
        <v-col :cols="$vuetify.breakpoint.smAndDown ? 12 : 9" class="mb-5">
          <div class="text--secondary" v-if="content.updated_at">
            Sidan uppdaterad {{ prettyDate(content.updated_at) }}
          </div>
        </v-col>
      </v-row>
      <v-row class="mt-5">
        <v-col cols="12">
          <h2>Exempel på arter i {{ getSelectedEnvName }}</h2>
        </v-col>
      </v-row>
      <v-row v-if="species">
        <v-col
          v-for="s in species"
          :key="s.id"
          :cols="$vuetify.breakpoint.smAndDown ? 12 : 3"
          class="d-flex child-flex"
        >
          <SpeciesCard class="" :species="s" />
        </v-col>
      </v-row>
      <v-row v-if="species">
        <v-col cols="12" class="d-flex justify-center">
          <v-btn color="primary" text @click="sampleSize = 1000">
            Se alla arter i livsmiljön
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import Setup from '@/mixins/Setup.js'
import Misc from '@/mixins/Misc.js'
import DataLayer from '@/store/PagesDataLayer'
import PostBlock from '@/components/PostBlock'
import SpeciesCard from '@/components/SpeciesCard.vue'
import _sampleSize from 'lodash/sampleSize'
import { format, parseISO } from 'date-fns'
export default {
  name: 'PageChildMiljo',
  props: { nameUrl: String },
  mixins: [Setup, Misc],
  components: {
    PostBlock,
    SpeciesCard
  },
  data() {
    return {
      content: null,
      page: null,
      sampleSize: 4
    }
  },
  watch: {
    $route: 'setup'
  },
  computed: {
    species() {
      const envId = this.$route.meta.envId
      const allSpecies = this.$store.getters.getAllSpecies
      const allSpecEnv = this.$store.state.allSpecEnvGroupByEnv

      const speciesInCurrentEnv = allSpecies.filter(spec =>
        allSpecEnv[envId].includes(spec.id)
      )
      return _sampleSize(speciesInCurrentEnv, this.sampleSize)
    },
    getSelectedEnvName() {
      return this.$route.meta.miljoName
      // return this.sections.find(s => s.id === this.selectedEnv).heading
    }
  },
  methods: {
    prettyDate(val) {
      try {
        return format(parseISO(val), 'yyyy-MM-dd')
      } catch (e) {
        return val
      }
    },
    setup() {
      const pageId = this.$route.meta.pageId
      DataLayer.GetPageById(pageId).then(res => {
        this.page = res.data[0]
      })
      DataLayer.GetItemsInPageById(pageId).then(res => {
        this.content = res.data[0]
      })
    }
  }
}
</script>

<style lang="scss" scoped></style>
